import content from './content';
import OptionList from './views/option-list';
import OptionItem from './views/option-item';

export default function Options({service} : {service:string}) {
    const dataContent = content(service);

    return (
        <OptionList title={dataContent.title}> 
            <OptionItem list={dataContent.list}/>
        </OptionList>
    );
}